import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["frame"];
  static values = { interval: Number, active: Boolean };

  connect() {
    if (this.hasActiveValue && !this.activeValue) {
      return;
    }

    this.startPolling();
  }

  disconnect() {
    this.stopPolling();
  }

  activeValueChanged(active) {
    if (active) {
      this.startPolling();
    } else {
      this.stopPolling();
    }
  }

  startPolling() {
    if (this.timer) {
      return;
    }

    const interval = this.hasIntervalValue ? this.intervalValue : 5000;
    this.timer = setInterval(() => {
      this.reload();
    }, interval);
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  reload() {
    if (this.hasFrameTarget) {
      this.frameTarget.src = window.location.href;
    }
  }
}
